import axios from "axios";

/**
 * Portal de rastreabilidade: é a única parte do app aberta ao público, então
 * usa um axios próprio em vez do cliente compartilhado — este não manda token
 * nem redireciona para o login em caso de 401.
 */
export class RastreioRepository {
	constructor() {
		this.axios = axios.create({
			baseURL: process.env.REACT_APP_BASE_URL,
			timeout: 30000,
		});
	}

	async getByCodigo(codigo) {
		try {
			const result = await this.axios.get(
				`rastreio-distribuidor/${encodeURIComponent(codigo)}`,
			);
			return result.data;
		} catch (error) {
			if (error.response?.status === 404) {
				throw new Error("Código de rastreio não encontrado.");
			}
			if (error.response?.status === 400) {
				throw new Error("Código de rastreio inválido.");
			}
			throw new Error("Não foi possível consultar a rastreabilidade agora.");
		}
	}

}
